import { render } from "./SortTableIncidentSheetComponent.vue?vue&type=template&id=52b3d044&scoped=true"
import script from "./SortTableIncidentSheetComponent.vue?vue&type=script&lang=js"
export * from "./SortTableIncidentSheetComponent.vue?vue&type=script&lang=js"

import "./SortTableIncidentSheetComponent.vue?vue&type=style&index=0&id=52b3d044&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b3d044"]])

export default __exports__